import { Card } from './cards/list';
import { useState } from 'react';

export function UnitsList({ units, style, amenities }) {
    const [moreOpen, setMoreOpen] = useState(false);
    if(units.length == 0) return null;

    const firstFour = units.slice(0,4);
    const theRest = units.slice(5);

    const LoadMore = () => {
        if(moreOpen) {
            return (
                <>
                    <div  className="rentals-section__list">
                        {theRest.map(unit => (
                            <Card unit={ unit } amenities={ amenities } key={unit.apartmentId} />
                        ))}
                    </div>
                </>
            )
        }
        return (
            <>
                <div  className="rentals-section__list rentals-section__list--more">
                    {theRest.map(unit => (
                        <Card unit={ unit } amenities={ amenities } key={unit.apartmentId} />
                    ))}
                </div>
                <a onClick={ () => setMoreOpen(true) } className="button">Load More</a>
            </>
        )
    }

    return(
        <div>
            <h2 className="rentals-section__headline">All Rental Availability</h2>
            <p>The following reflects all current availability in order of proximity to your search criteria. </p>
            <div className="rentals-section__list">
                {firstFour.map(unit => (
                    <Card unit={ unit } amenities={ amenities } key={unit.apartmentId} />
                ))}
            </div>

            { LoadMore() }

        </div>
    );
}